import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Upload, Eye, MessageCircleHeart } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: <Upload className="w-5 h-5 text-dark" data-id="element-157" />,
    text: 'Upload photos instantly'
  }, {
    icon: <Eye className="w-5 h-5 text-dark" data-id="element-158" />,
    text: 'View all shared moments live'
  }, {
    icon: <MessageCircleHeart className="w-5 h-5 text-dark" data-id="element-159" />,
    text: 'Leave messages & wishes'
  }];
  return <section className="py-24 px-6 bg-dark overflow-hidden" data-id="element-160">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center" data-id="element-161">
        <FadeIn direction="right" className="order-2 lg:order-1 relative" data-id="element-162">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(201,168,76,0.15)] border border-gold/20" data-id="element-163">
            <img src="https://cdn.magicpatterns.com/uploads/1NqASujQ2gBC91P1hVKxRD/heylloyd-image-1776622276664.png" alt="Elegant TapShare wedding sign on a table" className="w-full h-auto object-cover brightness-105 contrast-105 saturate-[1.05]" data-id="element-164" />
          </div>
          {/* Decorative glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gold/10 blur-[80px] -z-10" data-id="element-165"></div>
        </FadeIn>

        <div className="order-1 lg:order-2" data-id="element-166">
          <FadeIn data-id="element-167">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-cream mb-6" data-id="element-168">
              One Tap. <br data-id="element-169" />
              <span className="text-gold italic" data-id="element-170">Every Memory.</span> Forever.
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-171">
            <p className="text-lg text-cream-dark/80 mb-8 font-light" data-id="element-172">
              TapShare is a smart NFC event sign that lets guests instantly
              connect to your event.
            </p>
          </FadeIn>

          <div className="space-y-4 mb-10" data-id="element-173">
            {features.map((feature, index) => <FadeIn key={index} delay={0.3 + index * 0.1} className="flex items-center gap-4" data-id="element-174">
                <div className="w-10 h-10 rounded-full bg-gold flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-175">
                  {feature.icon}
                </div>
                <span className="text-xl text-cream" data-id="element-176">{feature.text}</span>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} data-id="element-177">
            <p className="text-xl font-medium text-gold mb-8 border-l-2 border-gold pl-4 py-1" data-id="element-178">
              All in one private gallery — no apps needed.
            </p>
            <Button data-id="element-179">👉 Order Now on Etsy</Button>
          </FadeIn>
        </div>
      </div>
    </section>;
}